import React from "react";
import "../../../App.css";
import "./ourTeam.css";
import PageHero from "../../PageHero.js";
import { Stagger, Reveal } from "../../motion/Reveal.js";
import Siddh from "./pictures/siddhPhoto.jpeg";
import Madhavan from "./pictures/madhavanPhoto.jpg";
import Krish from "./pictures/krishPhoto.jpg";
import Trung from "./pictures/trungPhoto.png";
import Aarya from "./pictures/aaryaPhoto.jpg";
import Aahish from "./pictures/aahishPhoto.jpg";
import Aadi from "./pictures/aadiPhoto.jpg";
import Adam from "./pictures/adamPhoto.jpg";
import Adi from "./pictures/adiPhoto.png";
import Arnav from "./pictures/arnavPhoto.jpg";
import Kabir from "./pictures/kabirPhoto.jpg";
import Ayur from "./pictures/ayurPhoto.jpg";
import Advith from "./pictures/advithPhoto.jpg";
import Brian from "./pictures/brianPhoto.jpg";
import Connor from "./pictures/connorPhoto.jpg";
import Dipen from "./pictures/dipenPhoto.png";
import Emad from "./pictures/emadPhoto.png";
import Emily from "./pictures/emilyphoto.jpg";
import Gayatri from "./pictures/gayatriPhoto.jpg";
import Harsh from "./pictures/harshPhoto.png";
import Harshith from "./pictures/harshithPhoto.jpg";
import Ishan from "./pictures/ishanPhoto.jpg";
import KatherineM from "./pictures/katherineMPhoto.jpg";
import KatherineS from "./pictures/katherineSPhoto.jpg";
import Mahesh from "./pictures/maheshPhoto.jpg";
import Medha from "./pictures/medhaPhoto.png";
import Nishad from "./pictures/nishadPhoto.png";
import Pratap from "./pictures/pratapPhoto.jpg";
import Pranav from "./pictures/pranavPhoto.png";
import Raashid from "./pictures/raashidPhoto.jpg";
import Raghu from "./pictures/raghuPhoto.jpg";
import Sai from "./pictures/saiPhoto.jpg";
import Sanjay from "./pictures/sanjayPhoto.png";
import Satya from "./pictures/satyaPhoto.png";
import Shivam from "./pictures/shivamPhoto.jpg";
import Lillian from "./pictures/lillianPhoto.jpg";
import Shreya from "./pictures/shreyaPhoto.jpg";
import Sree from "./pictures/sreePhoto.jpg";
import Tej from "./pictures/tejPhoto.png";
import Vedanth from "./pictures/vedanthPhoto.png"


import { FaLinkedin } from "react-icons/fa"; 


function TeamCard({image, name, position, bio, linkedIn}) {
    return (
        <Reveal className="aw-card aw-card--hover teamCard">
            <div className="teamCard__photo">
                <img src={image} alt={"Photo of " + name} loading="lazy" />
            </div>

            <div className="teamCard__body">
                <div className="teamCard__head">
                    <p className="teamCard__name">{name}</p>
                    {linkedIn && (
                        <a
                            href={linkedIn}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="teamCard__linkedin"
                            aria-label={name + " on LinkedIn"}
                        >
                            <FaLinkedin size={20} />
                        </a>
                    )}
                </div>
                {position && <p className="teamCard__role">{position}</p>}
                <p className="teamCard__bio">{bio}</p>
            </div>
        </Reveal>
    );
}

function TeamGroup({title, members}) {
    return (
        <section className="aw-section aw-section--tight teamGroup">
            <Stagger className="aw-container" gap={0.06} amount={0.05}>
                <Reveal className="teamGroup__head">
                    <h2 className="aw-display aw-h2 teamGroup__title">{title}</h2>
                    <hr className="aw-rule" />
                </Reveal>

                <div className="teamGroup__grid">
                    {members.map((member, index) => (
                        <TeamCard key={index} {...member} />
                    ))}
                </div>
            </Stagger>
        </section>
    );
}
const boardOfDirectors = [
        {
        image: Trung,
        name: "Trung Nguyen",
        position: "",
        bio: "I'm Trung, a sophomore in college who is passionate about managing non-profits, finances, and benefiting society.",
        linkedIn: "https://www.linkedin.com/in/trung-nguyen-150ba3254/",
    },
    {
        image: Madhavan,
        name: "Madhavan Rajagopalan",
        position: "",
        bio: "I'm Madhavan, a sophomore in college who is passionate about helping the community and managing volunteers.",
        linkedIn: "https://www.linkedin.com/in/madhavan-rajagopalan-590597299/",
    },
    {
        image: Krish,
        name: "Krish Jain",
        position: "",
        bio: "I'm Krish, a sophomore in college who enjoys coding, teaching, and giving back to the community.",
        linkedIn: "https://www.linkedin.com/in/krishjain718",
    },
    {
        image: Aadi,
        name: "Aadi Dixit",
        position: "",
        bio: "I'm Aadi, a freshman in college who loves to problem-solve and help others within our community.",
        linkedIn: "https://www.linkedin.com/in/aadi-dixit-0b084a288/",
    },
];

const ourTeam = [
    {
        image: Gayatri,
        name: "Gayatri Iyer",
        position: "Chief Executive Officer",
        bio: "I'm Gayatri, a high school senior who is very interested in volunteering, community service, and business & finance projects.",
        linkedIn: "https://www.linkedin.com/in/gayatri-iyer-907419317/"
    },
    {
        image: Satya,
        name: "Satya Divakaruni",
        position: "Chief Operating Officer",
        bio: "I'm Satya, a junior in high school and I enjoy helping others through various different community service projects and campaigns.",
        linkedIn: null
    },
    {
        image: Raghu,
        name: "Raghu Rajagopalan",
        position: "Chief Human Resources Officer",
        bio: "I'm Raghu, a high school sophomore passionate about volunteering and enthusiastic about helping our community.",
        linkedIn: null
    },
    {
        image: Brian,
        name: "Brian Olsen",
        position: "Deputy Chief Human Resources Officer",
        bio: "I'm Brian, a high school senior passionate about basketball, golf, education, and helping others.",
        linkedIn: "https://www.linkedin.com/in/brian-olsen-9195b7388/",
    },
    {
        image: Kabir,
        name: "Kabir Tiwari",
        position: "Head of Technology",
        bio: "I'm Kabir, a student and passionate programmer with a strong foundation in Python, Swift, and Flutter who loves building technology that helps others.",
        linkedIn: "https://www.linkedin.com/in/kabir-tiwari-86685b378"
    },
    {
        image: Pratap,
        name: "Pratap Srivastava",
        position: "Head of Marketing",
        bio: "I'm Pratap, an high school senior who loves playing piano, cars, aviation, and staying active.",
        linkedIn: "https://www.linkedin.com/in/pratap-srivastava-2339a5313/"
    },
    {
        image: Mahesh,
        name: "Mahesh Manneru",
        position: "Head of Finance",
        bio: "I'm Mahesh, a high school senior who loves to code and play chess. I want to make a good change in our community.",
        linkedIn: "https://www.linkedin.com/in/mahesh-manneru-4b282a304/"
    },
    {
        image: Harsh,
        name: "Harsh Cheepurpalli",
        position: "Head of Volunteering",
        bio: "I'm Harsh, a high school junior who enjoys playing basketball and running track, and I strive to bring change in my community.",
        linkedIn: "https://www.linkedin.com/in/harshit-cheepurpalli-435596348/"
    },
    {
        image: Dipen,
        name: "Dipen Sunda",
        position: "Volunteer Coordinator",
        bio: "My name is Dipen. I'm actively involved in HOSA, Model UN, and IYG at SHS. I have a strong interest in STEM and am deeply committed to helping the community.",
        linkedIn: null
    },
    {
        image: Emad,
        name: "Emad Makhdumi",
        position: "Volunteering Department",
        bio: "Hey! My name is Emad, I'm a senior in high school and I love basketball, lifting weights, and helping out the community through various initiatives.",
        linkedIn: null
    },
    {
        image: Pranav,
        name: "Pranav Deepak",
        position: "Volunteering Department",
        bio: "Hi I'm Pranav Deepak I'm a junior in high school I'm passionate in singing and I look forward to help in making a better community through volunteering.",
        linkedIn: null
    },
    {
        image: Sai,
        name: "Sai Saravanan",
        position: "Volunteering Department",
        bio: "I'm Sai, a high school sophomore who loves playing soccer and basketball, and enjoys working with others and helping out the community",
        linkedIn: "https://www.linkedin.com/in/sai-saravanan-272874400/ "
    },
    {
        image: Aarya,
        name: "Aarya Deepak",
        position: "Finance Department",
        bio: "I'm Aarya, a freshman in college who loves helping out his local community through fundraising and volunteering.",
        linkedIn: "https://www.linkedin.com/in/aarya-deepak-938272342/"
    },
    {
        image: Sanjay,
        name: "Sanjay Pappu",
        position: "Finance Department",
        bio: "I’m Sanjay. I’m a high school sophomore who loves to play basketball, run track, and sing. I joined Aidworks because every child deserves and equal opportunity to succeed.",
        linkedIn: null
    },
    {
        image: Nishad,
        name: "Nishad Basrur",
        position: "Finance Department",
        bio: "I’m Nishad, a high school senior who loves cars, and helping the community out through volunteering through different ways.",
        linkedIn: "https://www.linkedin.com/in/nishad-basrur-63102031b/"
    },
    {
        image: Aahish,
        name: "Aahish Abbani",
        position: "Finance Department",
        bio: "Hey, I’m Aahish Abbani, a high school freshman who’s passionate about finance, business, and community volunteering, and I love hanging out with friends!",
        linkedIn: null
    },
        {
        image: Medha,
        name: "Medha Manneru",
        position: "Finance Department",
        bio: "My name is Medha, and I'm currently a freshman in high school who enjoys working with new people and building a strong community.",
        linkedIn: null
    },
    {
        image: Raashid,
        name: "Raashid Abdullah",
        position: "Public Health Department",
        bio: "I'm Raashid, a high school senior who loves to do art, is ecstatic about biology, and likes to volunteer to give back to the community.",
        linkedIn: "https://www.linkedin.com/in/raashid-abdullah-1aab3a332/"
    },
    {
        image: Shreya,
        name: "Shreya Saikia",
        position: "Public Health Department",
        bio: "Hi my name is Shreya and I am excited to be apart of a community that’s passionate about public health!",
        linkedIn: null
    },
    {
        image: KatherineM,
        name: "Katherine Mui",
        position: "Public Health Department",
        bio: "Hi I’m Katherine. I’m passionate about helping our community and I’m excited to be apart of TAWF!",
        linkedIn: "https://www.linkedin.com/in/katherine-mui-259a05384"
    },
    {
        image: Lillian,
        name: "Lillian Wen",
        position: "Public Health Department",
        bio: "I’m Lillian, a senior passionate about public health and committed to supporting community wellness through education and outreach.",
        linkedIn: null
    },
];

const pastMembers = [
    {
        image: Siddh,
        name: "Siddh Patel",
        position: "Former Chief Human Resources Officer",
        bio: "I'm Siddh, a sophomore in college who enjoys outdoor activities, talking, and helping out my community.",
        linkedIn: "https://www.linkedin.com/in/siddh-patel-80a029279/",
    },
    {
        image: Arnav,
        name: "Arnav Sharma",
        position: "Former Head of Technology",
        bio: "I'm Arnav, a sophomore in college who enjoys coding, calisthenics and giving back to the community.",
        linkedIn: "https://www.linkedin.com/in/arnav-sharma-26252622a"
    },
    {
        image: Ishan,
        name: "Ishan Jain",
        position: "Former Head of Finance",
        bio: "I'm Ishan, a high school senior passionate about giving back to communities, having fun, and designing my own CAD projects.",
        linkedIn: "https://www.linkedin.com/in/ishan-jain-728890315/",
    },
    {
        image: Emily,
        name: "Emily Chow",
        position: "Former Head of Marketing",
        bio: "I'm Emily, a high school senior, musician, and rhythmic gymnastics coach who aims to create a more uplifting community!",
        linkedIn: "https://www.linkedin.com/in/emily-chow-61b4b7312/",
    },
    {
        image: KatherineS,
        name: "Katherine Shan",
        position: "Marketing Department",
        bio: "I’m Katherine, a high school senior, dancer, and rhythmic gymnastics coach. I love volunteering whenever I can and helping others!",
        linkedIn: "https://www.linkedin.com/in/katherine-shan-b3a8b6369/"
    },
    {
        image: Advith,
        name: "Advith Velamakanni",
        position: "Marketing Department",
        bio: "I'm Advith, a freshman in college passionate about filmmaking, fencing, and supporting our community.",
        linkedIn: "https://www.linkedin.com/in/advith-velamakanni-aa7b3031b/"
    },
    {
        image: Connor,
        name: "Connor Duffy",
        position: "Marketing Department",
        bio: "I'm Connor, a junior in college who is passionate about fostering positivity and hope through community service and outreach.",
        linkedIn: "https://www.linkedin.com/in/connor-duffy-24219b372/"
    },
    {
        image: Adi,
        name: "Adi Kinhikar",
        position: "Volunteer Coordinator",
        bio: "I’m Adi, a senior in high school passionate about helping the community through fundraisers and more.",
        linkedIn: "https://www.linkedin.com/in/adi-kinhikar-15a148315/"
    },
    {
        image: Sree,
        name: "Sreevatsen Kumar",
        position: "Former Head of Volunteering",
        bio: "I'm Sree, a freshman in college that loves playing video games, going for runs to stay active as well as building things using CAD.",
        linkedIn: null
    },
    {
        image: Vedanth,
        name: "Vedanth Saranath",
        position: "Former Cross-Departmental Specialist",
        bio: "I'm Vedanth, a freshman in college who is passionate about coding and photography and is always open to learn more.",
        linkedIn: "https://www.linkedin.com/in/vedanth-saranath/"
    },
    {
        image: Tej,
        name: "Tejpravin Ravikumar",
        position: "Former Volunteer Coordinator",
        bio: "I'm Tejpravin Ravikumar, and I am an enthusiastic, determined college freshman who wishes to promote goodwill.",
        linkedIn: "http://linkedin.com/in/tejpravin-ravikumar-ab5b2230b/"
    },
    {
        image: Shivam,
        name: "Shivam Goel",
        position: "Former Public Health Coordinator",
        bio: "I'm Shivam, a sophomore in college passionate about giving back to my community, helping others, and medicine.",
        linkedIn: null
    },
    {
        image: Adam,
        name: "Adam Munch",
        position: "Former Head of Technology",
        bio: "I’m Adam, a freshman in college who loves to problem-solve and help others within our community.",
        linkedIn: "https://www.linkedin.com/in/adam-munch-78baa48b/"
    },
    {
        image: Harshith,
        name: "Harshith Mothkuri",
        position: "Former Logistics Coordinator",
        bio: "I'm Harshith, a freshman in college who enjoys communcating with people as well as helping our community and people.",
        linkedIn: null
    },
    {
        image: Ayur,
        name: "Ayur Nikhade",
        position: "Former Logistics Coordinator",
        bio: "I'm Ayur, a student passionate about the humanities. My goal is to bring a change in the community and make the world a better place.",
        linkedIn: "https://www.linkedin.com/in/ayur-nikhade-087b2430b/"
    },
    

]

function OurTeam() {
    return (
        <div className="teamPage">
            <PageHero
                eyebrow="Who We Are"
                title="Our"
                accent="Team"
                lead="We are a group of passionate and dedicated high schoolers and college students committed to making a positive impact in our community. Through our collective efforts, we aim to lend a helping hand to those in need, foster connections, and create a better environment for everyone."
            />

            <TeamGroup title="Our Team" members={ourTeam} />
            <TeamGroup title="Board of Directors" members={boardOfDirectors} />
            <TeamGroup title="Our Alumni" members={pastMembers} />
        </div>
    );
}

export default OurTeam;
